// extracted by mini-css-extract-plugin
export var founderSection = "styles-mod--founder-section--f5d15";
export var founderSectionBox = "styles-mod--founder-section-box--bb50e";
export var foundersContent = "styles-mod--founders-content--c5dab";
export var foundersImage = "styles-mod--founders-image--827c6";
export var newFoundersContent = "styles-mod--new-founders-content--b6b2d";
export var newFoundersImage = "styles-mod--new-founders-image--6b26c";
export var newSignatureFooter = "styles-mod--new-signature-footer--e31ee";
export var rightSideImage = "styles-mod--right-side-image--ff394";
export var signature = "styles-mod--signature--9d33b";
export var signatureFooter = "styles-mod--signature-footer--31254";
export var text = "styles-mod--text--c9949";